module.exports = __webpack_public_path__ + "img/6-15_Optimization.9de87153.png";